import RequestCompanyCTA from 'components/widgets/CompanySearch/RequestCompanyCTA';

type Props = {
  companyNameQuery: string;
};

const NoResultsFound = ({ companyNameQuery }: Props) => {
  return <RequestCompanyCTA companyNameQuery={companyNameQuery} showMessage />;
};

export default NoResultsFound;
